import React from 'react';
import LoginModal from '../login/email_login_modal';
import { getUIState } from '../utils/auth_utils';

function NavbarTop() {
  const showContact = false
  const uiState=getUIState()
  console.log(" ui state "+uiState)
  return (
    <div className="flex flex-col">

    <nav className="fixed top-0 left-0 z-50 w-full bg-white text-gray-800 py-1 px-6 border-b border-gray-200">
    {/*  <div className="flex items-center justify-between">
        <a href="#" className="text-xl font-bold">Your Website</a>
        <button className="bg-gray-800 hover:bg-gray-700 text-white px-3 py-2 rounded-md">Menu</button>
      </div>
  */}
    <div className=" flex items-center justify-between mt-2">
      {/* buttons which are shown only on desktop/laptop */}
      <div className="hidden md:flex md:space-x-4"> 
        <a href="/" className="text-2xl px-4 py-2 font-bold mr-6 
         hover:bg-gray-100 hover:text-black border-2 border-gray-600">
        MockGym</a>
      {  <a href="/" className="mr-6 px-4 py-2
        text-lg font-sans rounded-full
          text-gray-700 hover:text-black
          hover:bg-teal-100 
          ">Home</a>
      }  
      

      { /*
       <a href="/wholesale" className="mr-6 px-4 py-2 
      text-gray-800 font-sans 
         hover:bg-gray-100 hover:text-black">
          Bulk Subscription</a>
      */}

      {
        <a href="https://codezym.com/roadmap"
          className="mr-6 px-4 py-2 rounded-full text-gray-700
           hover:bg-teal-100 hover:text-black"
          target='_blank'>LLD Roadmap</a>
    }

     {  <a href="/about" className="mr-6 px-4 py-2
        text-lg font-sans rounded-full
          text-gray-700 hover:text-black
          hover:bg-teal-100 
          ">Why MockGym ??</a>
      }  

    {  <a href="/premium" className="mr-6 px-4 py-2
        text-lg font-sans rounded-full
          text-white bg-teal-500 
          hover:bg-teal-600 
          ">Premium</a>
      }
      { 
      /*
        <a href="#" className="mr-6 px-4 py-2 hover:bg-gray-600 ">Premium</a>
      */
      }
      
       { false && <a href="/about" className="mr-6 px-4 py-2 hover:bg-gray-100  hover:text-black">
       Why MockGym ?</a>
       }
      
      { showContact &&   <a href="#" className="mr-6 px-4 py-2 hover:bg-gray-100 hover:text-black">Contact</a>
      }
      </div>
       
        {/* Mobile Menu Button (Shown on Mobile) */}
        <div className="md:hidden">
        <a href="/" className="text-xl  mr-4  font-bold   hover:bg-gray-100 hover:text-black">MockGym</a>
          </div>

          {/* Mobile Menu Buttons (Hidden on Medium and Larger Screens) */}
          <div className="flex align-middle text-center md:hidden text-gray-900">
          
       { showContact &&   <a href="#" className="text-sm  hover:bg-gray-100 hover:text-black">Contact</a>
        }
          </div>

        <div>
        <LoginModal />
      {/*  
          
      */}
         {/* <button className="bg-gray-900 hover:bg-gray-600 text-white px-3 py-2 rounded-md">Login/SignUp</button>
         */}
        </div>
      </div>
    </nav>

         
    </div>
  );
}

function NavbarWithOnlyHome() {

  return (
    <nav className="fixed top-0 left-0 z-50 w-full bg-white text-gray-800 py-1 px-6 border-b border-gray-200">
    
      <div className=" flex items-center justify-between mt-2">
        <div className="hidden md:flex md:space-x-4"> 
          <a href="/" className="text-3xl px-4 py-2 font-bold mr-6  hover:bg-gray-100 hover:text-black">
          MockGym</a>
        
         {/* 
         <a href="/" className="mr-6 px-4 py-2 hover:bg-gray-100  hover:text-black">Home</a>
      */}

      
        </div>
      </div>
    </nav>
  );
}

export  {NavbarTop, NavbarWithOnlyHome};
